import Vue from 'vue'
import * as VueGoogleMaps from 'gmap-vue'

Vue.component('GmapGroundOverlay', VueGoogleMaps.MapElementFactory({
  mappedProps: {
    opacity: {}
  },
  props: {
    source: { type: String },
    bounds: { type: Object },
    isShown: { type: Boolean }
  },
  events: ['click', 'dblclick'],
  name: 'GmapGroundOverlay',
  ctr: () => google.maps.GroundOverlay,
  ctrArgs: (
    options: google.maps.GroundOverlayOptions,
    { source, bounds }: {
            source: string,
            bounds: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral
          }
  ) => {
    return [source, bounds, options]
  },
  afterCreate: function () {
    if (!this.isShown) {
      this.$GmapGroundOverlayObject.setOpacity(0)
    }
  },
  watch: {
    isShown: function (val: boolean) {
      if (val) {
        // @ts-ignore
        this.$GmapGroundOverlayObject.setOpacity(1)
      } else {
        // @ts-ignore
        this.$GmapGroundOverlayObject.setOpacity(0)
      }
    }
  }
}))
